import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import back from '@/components/back'
import home from "@/components/home"
import info from "@/components/info"
import addSchool from "@/components/add_school";
import result from "@/components/result";
import user_service from "./../service/user_service";
import schoolList from "@/components/schoolList";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/back',
      name: 'back',
      // meta: {
      //   requireAuth: true
      // },
      component: back
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requireAuth: true
      },
      component: home
    },
    {
      path: '/info',
      name: 'info',
      meta: {
        requireAuth: true
      },
      component: info
    },
    {
      path: '/addSchool',
      name: 'addSchool',
      meta: {
        requireAuth: true
      },
      component: addSchool
    },
    {
      path: '/result',
      name: 'result',
      meta: {
        requireAuth: true
      },
      component: result
    },
    {
      path: '/schoolList',
      name: 'schoolList',
      meta: {
        requireAuth: true
      },
      component: schoolList
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  console.log(to, '===>to');
  console.log(from, '====from');
  if (to.meta.requireAuth) {
    // 判断跳转的路由是否需要登录
    if (Vue.cookie.get('access_token')) {
      // 判断重复登录
      next();
    } else {
      next({
        path: '/home'
      });
    }
  } else {
    next();
  }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js